import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid"; // heroicons for success icon
import { useNavigate, useLocation } from "react-router-dom";

const SuccessPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { title, message } = location.state || {}; // fallback if no state passed


    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-6">
            {/* Success Icon */}
            <CheckCircleIcon className="w-20 h-20 text-green-500 mb-6" />

            {/* Success Message */}
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
                {title}
            </h1>
            <p className="text-gray-500 text-center max-w-sm mb-6">
                {message}
            </p>

            {/* Action Button */}
            <button
                onClick={() => navigate("/dasbhoard")}
                className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-md transition-all duration-200 font-medium"
            >
                Back to Dashboard
            </button>
        </div>
    );
};

export default SuccessPage;
